import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    CurrencyEntryDto,
    CreateCurrencyEntryDto,
} from '../../../core/data/new-dtos/insurance-type.dtos';
@Injectable({
    providedIn: 'root',
})
export class CurrenciesService {
    private baseUrl = 'Currencies';

    constructor(private http: HttpClient) { }

    getAll(): Observable<CurrencyEntryDto[]> {
        return this.http.get<CurrencyEntryDto[]>(this.baseUrl);
    }

    create(dto: CreateCurrencyEntryDto): Observable<number> {
        return this.http.post<number>(this.baseUrl, dto);
    }
}
